import {
  DeleteOutlined,
  DownloadOutlined,
  PaperClipOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button, List, Progress, Upload } from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';

const buildObj = (value) => {
  return {
    name: value?.submitiedFileName,
    id: value?.fileId,
    thumbnail: '',
    status: 'done',
    size: value?.fileSize,
    url: value?.filePath,
    path: value?.filePath,
  };
};
const reBuildObj = (value, index) => {
  return {
    uid: index,
    name: value?.name,
    id: value?.id,
    thumbnail: value?.thumbnail,
    size: value?.size,
    status: 'done',
    url: value?.url,
    path: value?.path,
  };
};
const handleDownload = (fileUrl) => {
  // Thực hiện tải xuống tệp tin
  fetch(fileUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
      a.click();
    })
    .catch((error) => {
      console.error(error);
    });
};
const customItemRender = (originNode, file, fileList, actions) => {
  const { remove } = actions;
  const isDone = file.status === 'done';
  const isErr = file.status === 'error';
  const isUploading = file.status === 'uploading';
  const status =
    (isDone && 'success') ||
    (isErr && 'exception') ||
    (isUploading && 'active');
  let actionsItems = [
    !file.url ? (
      <div
        style={{
          width: 32,
        }}
      >
        <Progress
          status={status || undefined}
          percent={file.percent}
          size='small'
        />
      </div>
    ) : undefined,
    file.url ? (
      <DownloadOutlined
        disabled={true}
        onClick={() => handleDownload(file.url)}
      />
    ) : undefined,
    <DeleteOutlined onClick={remove} />,
  ];
  actionsItems = actionsItems.filter((f) => f != undefined);
  return (
    <List.Item style={{ padding: 'unset' }} actions={actionsItems}>
      <List.Item.Meta avatar={<PaperClipOutlined />} title={file.name} />
    </List.Item>
  );
};

const UploadFile = ({
  action,
  maxCount = 1,
  defaultResp = false,
  ...props
}) => {
  const [fileList, setFileList] = useState([]);

  const handleCustomRequest = (options) => {
    const { onSuccess, onError, file } = options;
    const formData = new FormData();
    formData.append('file', file);

    // Gửi request tải lên đến API upload của bạn
    fetch(action, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        const { err, error, msg, message, data: responseData } = data;
        if (err === 0 || error === 0) {
          const { file: uploadedFile } = responseData;
          const response = !defaultResp ? buildObj(uploadedFile) : uploadedFile;
          onSuccess(response);
        } else {
          onError(msg | message);
        }
      })
      .catch((error) => {
        onError(error.message || error.msg);
      });
  };

  const handleOnChange = ({ fileList: newFileList }) => {
    const list = newFileList.map((e) => e.response || e);
    setFileList(newFileList);
    props.onChange && props.onChange(list);
  };

  useEffect(() => {
    if (_.isEmpty(props.value) && _.isEmpty(fileList)) {
      return;
    }
    if (!_.isEmpty(props.value) && _.isEmpty(fileList)) {
      const defValue = (props.value && props.value.map(reBuildObj)) || [];
      setFileList(defValue);
    }
  }, [props.value]);

  return (
    <div
      style={{
        border: '1px solid #d9d9d9',
        padding: '1em',
        borderRadius: '8px',
      }}
    >
      <Upload
        {...props}
        listType='text'
        customRequest={handleCustomRequest}
        onChange={handleOnChange}
        fileList={fileList}
        itemRender={customItemRender}
        multiple={maxCount > 1}
      >
        <Button icon={<UploadOutlined />}>Nhấn để tải lên</Button>
      </Upload>
    </div>
  );
};

export default UploadFile;
